import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { ToasterService } from '../../services/toaster.service';

import { UsersService } from '../../../pages/pages/users/users.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { AddEditIdentificationComponent } from './add-edit-identification/add-edit-identification.component';

@Component({
  selector: 'gtapp-identification',
  templateUrl: './identification.html',
  styleUrl: './identification.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class Identification implements OnInit {
  identificationsDataList: any = [];

  @Input() showFrom: string = 'profilePage';
  @Input() userId: string = '';
  @Input() subContractorId: string = '';

  constructor(
    private spinnerService: LoadingSpinnerService,
    private dialogService: ModalDialogueService,
    private userService: UsersService,
    private toasterService: ToasterService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
    this.getCredentialsListData();
  }
  getCredentialsListData() {
    let params: any = {
      credential_owner:
        this.showFrom === 'companyProfilePage'
          ? 'subscriber'
          : this.showFrom === 'subContractorPage'
            ? 'sub_contractor'
            : 'user',
    };
    if (this.showFrom === 'profilePage') {
      //  (TYPE_APPROVED = 1), _('approved');
      //  (TYPE_PENDING = 2), _('pending');
      //  (TYPE_REJECTED = 3), _('rejected');
      params.credential_status = JSON.stringify([1, 2]);
    }
    if (this.showFrom === 'userDetailPage') {
      params.from_manage_cred_page = 1;
    }
    if (this.userId) {
      params.assignee_id = this.userId;
    }

    if (this.subContractorId) {
      params.sub_contractor_id = btoa(this.subContractorId);
    }

    this.userService.listIdentifications(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.identificationsDataList = response?.data;
        this.cdr.markForCheck();
      }
      this.spinnerService.hide();
    });
  }

  editCredential(identificationData: any) {
    const dialogRef = this.dialogService.open(AddEditIdentificationComponent, {
      data: {
        showFrom: this.showFrom,
        selectedIdentification: identificationData,
        subContractorId: this.subContractorId,
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getCredentialsListData();
      }
    });
  }
  addNewCred() {
    const dialogRef = this.dialogService.open(AddEditIdentificationComponent, {
      data: {
        showFrom: this.showFrom,
        subContractorId: this.subContractorId,
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res?.id) {
        this.identificationsDataList.push(res);
        this.cdr.markForCheck();
      } else if (res) {
        this.getCredentialsListData();
      }
    });
  }

  updateCredentialStatus(credential: any, status: any) {
    let dialogMsg = status === 'approve' ? 'Save?' : 'Remove?';
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: ``,
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        let params: any = {
          credential_owner:
            this.showFrom === 'companyProfilePage'
              ? 'subscriber'
              : this.showFrom === 'subContractorPage'
                ? 'sub_contractor'
                : 'user',
          from_manage_cred_page:
            this.showFrom == 'manageIdentificationPage' ? 1 : 0,
        };
        params[status] = 1;
        this.userService
          .updateIdentification(credential?.id, {}, params)
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
              if (status == 'Save') {
                const index = this.identificationsDataList?.findIndex(
                  (item: any) => item?.id == response?.data?.id,
                );

                if (index !== -1) {
                  this.identificationsDataList[index] = response?.data;
                  this.cdr.markForCheck();
                }
              } else {
                this.getCredentialsListData();
              }
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                errorMessage: response['message'],
                successMessage: '',
              });
            }
          });
      }
    });
  }
}
